<form [formGroup]="inspectForm" class="inspect-form-content fade display-flex flex-column grid-gap-16">
  <!-- Header -->
  <div class="display-flex align-items-center justify-content-space-between grid-gap-8">
    <span class="display-flex align-items-center grid-gap-8 text-item-name">
      <span class="display-flex">
        {{ currentArea?.areaName | truncateLength: 36:false }}
      </span>
      <app-icon
        class="separator-chevron"
        [svg]="EIcon.ANGLE_RIGHT"
        [iconWidth]="8"
        [iconHeight]="8"
        [iconColor]="EColorPalette.cGray2"></app-icon>
      <span class="display-flex">
        {{ inspectForm?.get('itemName')?.value | truncateLength: 36:false }}
      </span>
    </span>
    <div class="display-flex">
      <div class="display-flex grid-gap-2">
        <button
          *ngIf="hasUnsavedData(currentArea?.items[currentItemIndex])"
          mat-button
          matRipple
          matTooltip="Discard local changes"
          color="primary"
          type="button"
          aria-label="help-button"
          class="icon icon-restore"
          (click)="userClearFormDataFromLocalStorage(currentArea.items[currentItemIndex])">
          <mat-icon class="display-flex align-items-center justify-content-center">restore</mat-icon>
        </button>
        <button
          *ngIf="currentArea?.items[currentItemIndex]?.instructions"
          mat-button
          matRipple
          color="primary"
          type="button"
          aria-label="help-button"
          class="icon"
          (click)="openInstructions(currentArea.items[currentItemIndex]?.instructions)">
          <app-icon [svg]="EIcon.HELP" [iconWidth]="24" [iconHeight]="24" [iconColor]="EColorPalette.cGray5"></app-icon>
        </button>
      </div>
      <button
        mat-button
        matRipple
        color="primary"
        type="button"
        aria-label="close-button"
        class="icon"
        (click)="close()">
        <app-icon
          [svg]="EIcon.CLOSE_SMALL"
          [iconWidth]="24"
          [iconHeight]="24"
          [iconColor]="EColorPalette.cGray5"></app-icon>
      </button>
    </div>
  </div>

  <div class="display-flex flex-column grid-gap-16 content no-scrollbar">
    <!-- Emojis -->
    <span
      class="text-item-section"
      [ngClass]="{ 'ng-invalid': inspectForm.get('emojiDetails')?.invalid && inspectForm.get('emojiDetails')?.touched }"
      *ngIf="
        inspectForm?.get('emojiDetails')?.value?.length > 0 && inspectForm?.get('emojiDetails')?.value[0]?.emojiTitle
      ">
      {{ inspectForm?.get('emojiDetails')?.value[0]?.emojiTitle | truncateLength: 36:true:'' }}
      <span class="required">*</span>
    </span>
    <div
      class="display-flex emoji-container"
      *ngIf="
        inspectForm?.get('emojiDetails')?.value?.length > 0 && inspectForm?.get('emojiDetails')?.value[0]?.emojiCode
      ">
      <div
        class="display-flex flex-column align-items-center"
        *ngFor="let emoji of inspectForm?.get('emojiDetails')?.value; let i = index"
        (click)="setEmojiDefault(i)">
        <app-template-editor-animation
          class="emoji"
          [ngClass]="[
            emoji.isDefault ? 'emoji-true' : '',
            inspectForm.get('emojiDetails').invalid && inspectForm.get('emojiDetails').touched ? 'emoji-invalid' : ''
          ]"
          [attrHeight]="'32px'"
          [attrWidth]="'32px'"
          [animationItem]="emoji.emojiCode"></app-template-editor-animation>
        <span class="display-flex align-items-center">{{ emoji.emojiName | truncateLength: 9:true }}</span>
      </div>
    </div>

    <!-- Questions -->
    <ng-container formArrayName="questions">
      <div class="display-flex flex-column grid-gap-8" *ngIf="questions.controls.length > 0">
        <span class="text-item-section">Answer questions</span>

        <div class="display-flex flex-column grid-gap-16">
          <ng-container *ngFor="let question of questions.controls; let i = index" [formGroupName]="i">
            <ng-container [ngSwitch]="question.get('type')?.value">
              <!-- boolean questions -->
              <ng-container *ngSwitchCase="'boolean'">
                <div
                  class="display-flex justify-content-space-between"
                  [ngClass]="{
                    'ng-invalid': question.get('answer')?.invalid && question.get('answer')?.touched
                  }"
                  [attr.guid]="question.get('guid')?.value">
                  <div class="w-100 display-flex align-items-center">
                    <mat-icon
                      *ngIf="
                        question.get('displayMode')?.value === DisplayMode.Variance &&
                        question.get('answer')?.value !== null &&
                        question.get('answer')?.value !== undefined &&
                        question.get('answer')?.value !== ''
                      "
                      class="display-flex align-items-center done-all-icon"
                      [ngClass]="{
                        'done-all-icon-changed':
                          question.get('defaultAnswer')?.value !== null &&
                          question.get('defaultAnswer')?.value !== undefined &&
                          question.get('answer')?.value !== question.get('defaultAnswer')?.value
                      }">
                      done_all
                    </mat-icon>
                    <span
                      class="display-flex align-items-center question"
                      [ngClass]="{
                        'question-invalid': question.get('answer')?.invalid && question.get('answer')?.touched
                      }">
                      {{ question.get('question')?.value }}
                      <span *ngIf="question.get('isRequired')?.value !== false" class="required">*</span>
                    </span>
                  </div>

                  <div class="display-flex grid-gap-8">
                    <div
                      class="display-flex align-items-center justify-content-center icon-thumb icon-thumb-up"
                      [ngClass]="{
                        'icon-thumb-up-chosen':
                          question.get('answer')?.value !== null && question.get('answer')?.value !== undefined
                            ? question.get('answer')?.value === true
                            : question.get('defaultAnswer')?.value === true,
                        'icon-thumb-invalid': question.get('answer')?.invalid && question.get('answer')?.touched
                      }"
                      (click)="question.get('answer')?.setValue(true); question.get('answer')?.markAsTouched()">
                      <app-icon
                        [ngStyle]="{
                          opacity:
                            question.get('answer')?.value !== null && question.get('answer')?.value !== undefined
                              ? question.get('answer')?.value === true
                                ? 1
                                : 0.25
                              : question.get('defaultAnswer')?.value === true
                              ? 1
                              : 0.25
                        }"
                        [svg]="EIcon.THUMB_UP"
                        [iconWidth]="20"
                        [iconHeight]="20"
                        [iconColor]="EColorPalette.cGreen3"></app-icon>
                    </div>
                    <div
                      class="display-flex align-items-center justify-content-center icon-thumb icon-thumb-down"
                      [ngClass]="{
                        'icon-thumb-down-chosen':
                          question.get('answer')?.value !== null && question.get('answer')?.value !== undefined
                            ? question.get('answer')?.value === false
                            : question.get('defaultAnswer')?.value === false,
                        'icon-thumb-invalid': question.get('answer')?.invalid && question.get('answer')?.touched
                      }"
                      (click)="question.get('answer')?.setValue(false); question.get('answer')?.markAsTouched()">
                      <app-icon
                        [ngStyle]="{
                          opacity:
                            question.get('answer')?.value !== null && question.get('answer')?.value !== undefined
                              ? question.get('answer')?.value === false
                                ? 1
                                : 0.25
                              : question.get('defaultAnswer')?.value === false
                              ? 1
                              : 0.25
                        }"
                        [svg]="EIcon.THUMB_DOWN"
                        [iconWidth]="20"
                        [iconHeight]="20"
                        [iconColor]="EColorPalette.cRed3"></app-icon>
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- texts -->
              <ng-container *ngSwitchCase="'text'">
                <div class="display-flex flex-column" [attr.guid]="question.get('guid')?.value">
                  <div class="display-flex align-items-center mb-4">
                    <mat-icon
                      *ngIf="
                        question.get('displayMode')?.value === DisplayMode.Variance &&
                        question.get('value')?.value !== null &&
                        question.get('value')?.value !== undefined &&
                        question.get('value')?.value !== ''
                      "
                      class="display-flex align-items-center done-all-icon mb-4"
                      [ngClass]="{
                        'done-all-icon-changed':
                          question.get('defaultValue')?.value !== null &&
                          question.get('defaultValue')?.value !== undefined &&
                          question.get('value')?.value !== question.get('defaultValue')?.value
                      }">
                      done_all
                    </mat-icon>
                    <span class="question-title">
                      {{ question.get('title')?.value }}
                      <span *ngIf="question.get('isRequired')?.value !== false" class="required">*</span>
                    </span>
                  </div>
                  <app-input-area
                    formControlName="value"
                    [inputCss]="'hp-92'"
                    [attrPlaceholder]="'Enter text'"
                    [markAsInvalid]="submitted && question.get('value')?.invalid"
                    [errorSection]="false"></app-input-area>
                  <div
                    class="mt-4"
                    *ngIf="
                      question.get('displayMode')?.value === DisplayMode.Variance &&
                      question.get('defaultValue')?.value &&
                      question.get('value')?.value !== question.get('defaultValue')?.value
                    ">
                    Changed from {{ question.get('defaultValue')?.value }}
                  </div>
                </div>
              </ng-container>

              <!-- numbers -->
              <ng-container *ngSwitchCase="'number'">
                <div class="display-flex flex-column" [attr.guid]="question.get('guid')?.value">
                  <div class="display-flex align-items-center mb-4">
                    <mat-icon
                      *ngIf="
                        question.get('displayMode')?.value === DisplayMode.Variance &&
                        question.get('value')?.value !== null &&
                        question.get('value')?.value !== undefined &&
                        question.get('value')?.value !== ''
                      "
                      class="display-flex align-items-center done-all-icon mb-4"
                      [ngClass]="{
                        'done-all-icon-changed':
                          question.get('defaultValue')?.value !== null &&
                          question.get('defaultValue')?.value !== undefined &&
                          question.get('value')?.value !== question.get('defaultValue')?.value
                      }">
                      done_all
                    </mat-icon>
                    <span class="question-title">
                      {{ question.get('title')?.value }}
                      <span *ngIf="question.get('isRequired')?.value !== false" class="required">*</span>
                    </span>
                  </div>
                  <app-input
                    formControlName="value"
                    [attrMask]="'separator.2'"
                    [markAsInvalid]="!!(submitted && question.get('value')?.invalid)"
                    [attrPlaceholder]="'Enter number'"
                    [errorSection]="false"></app-input>

                  <div
                    class="mt-4"
                    *ngIf="
                      question.get('displayMode')?.value === DisplayMode.Variance &&
                      question.get('defaultValue')?.value &&
                      question.get('value')?.value !== question.get('defaultValue')?.value
                    ">
                    Changed from {{ question.get('defaultValue')?.value }}
                  </div>
                </div>
              </ng-container>

              <!-- ints -->
              <ng-container *ngSwitchCase="'int'">
                <div class="display-flex flex-column" [attr.guid]="question.get('guid')?.value">
                  <div class="display-flex align-items-center mb-4">
                    <mat-icon
                      *ngIf="
                        question.get('displayMode')?.value === DisplayMode.Variance &&
                        question.get('value')?.value !== null &&
                        question.get('value')?.value !== undefined &&
                        question.get('value')?.value !== ''
                      "
                      class="display-flex align-items-center done-all-icon mb-4"
                      [ngClass]="{
                        'done-all-icon-changed':
                          question.get('defaultValue')?.value !== null &&
                          question.get('defaultValue')?.value !== undefined &&
                          question.get('value')?.value !== question.get('defaultValue')?.value
                      }">
                      done_all
                    </mat-icon>
                    <span class="question-title">
                      {{ question.get('title')?.value }}
                      <span *ngIf="question.get('isRequired')?.value !== false" class="required">*</span>
                    </span>
                  </div>
                  <app-input
                    formControlName="value"
                    [markAsInvalid]="!!(submitted && question.get('value')?.invalid)"
                    [attrMask]="'separator.0'"
                    [attrPlaceholder]="'Enter integer'"
                    [errorSection]="false"></app-input>

                  <div
                    class="mt-4"
                    *ngIf="
                      question.get('displayMode')?.value === DisplayMode.Variance &&
                      question.get('defaultValue')?.value &&
                      question.get('value')?.value !== question.get('defaultValue')?.value
                    ">
                    Changed from {{ question.get('defaultValue')?.value }}
                  </div>
                </div>
              </ng-container>

              <!-- moneys -->
              <ng-container *ngSwitchCase="'money'">
                <div class="display-flex flex-column" [attr.guid]="question.get('guid')?.value">
                  <div class="display-flex align-items-center mb-4">
                    <mat-icon
                      *ngIf="
                        question.get('displayMode')?.value === DisplayMode.Variance &&
                        question.get('value')?.value !== null &&
                        question.get('value')?.value !== undefined &&
                        question.get('value')?.value !== ''
                      "
                      class="display-flex align-items-center done-all-icon mb-4"
                      [ngClass]="{
                        'done-all-icon-changed':
                          question.get('defaultValue')?.value !== null &&
                          question.get('defaultValue')?.value !== undefined &&
                          customFieldsService.parseAmount(question.get('value')?.value) !==
                            customFieldsService.parseAmount(question.get('defaultValue')?.value)
                      }">
                      done_all
                    </mat-icon>
                    <span class="question-title">
                      {{ question.get('title')?.value }}
                      <span *ngIf="question.get('isRequired')?.value !== false" class="required">*</span>
                    </span>
                  </div>
                  <app-input
                    formControlName="value"
                    [useCurrencyFormatter]="true"
                    [attrPlaceholder]="'Enter amount'"
                    [markAsInvalid]="!!(submitted && question.get('value')?.invalid)"
                    [errorSection]="false"></app-input>

                  <div
                    class="mt-4"
                    *ngIf="
                      question.get('displayMode')?.value === DisplayMode.Variance &&
                      question.get('defaultValue')?.value &&
                      customFieldsService.parseAmount(question.get('value')?.value) !==
                        customFieldsService.parseAmount(question.get('defaultValue')?.value)
                    ">
                    Changed from {{ question.get('defaultValue')?.value }}
                  </div>
                </div>
              </ng-container>

              <!-- dates -->
              <ng-container *ngSwitchCase="'date'">
                <div class="display-flex flex-column" [attr.guid]="question.get('guid')?.value">
                  <div class="display-flex align-items-center mb-4">
                    <mat-icon
                      *ngIf="
                        question.get('displayMode')?.value === DisplayMode.Variance && question.get('value')?.value
                      "
                      class="display-flex align-items-center done-all-icon mb-4"
                      [ngClass]="{
                    'done-all-icon-changed': question.get('defaultValue')?.value &&
                      question.get('value')?.value?.getTime?.() !== question.get('defaultValue')?.value?.getTime?.()
                  }">
                      done_all
                    </mat-icon>
                    <span class="question-title">
                      {{ question.get('title')?.value }}
                      <span *ngIf="question.get('isRequired')?.value !== false" class="required">*</span>
                    </span>
                  </div>
                  <app-date-dropdown
                    formControlName="value"
                    [isFullWidth]="true"
                    [attrPlaceholder]="'Choose date'"
                    [errorSection]="false"></app-date-dropdown>

                  <div
                    class="mt-4"
                    *ngIf="
                        question.get('displayMode')?.value === DisplayMode.Variance && question.get('defaultValue')?.value && question.get('value')?.value?.getTime?.() !== question.get('defaultValue')?.value?.getTime?.()">
                    Changed from {{ question.get('defaultValue')?.value | date: 'shortDate' }}
                  </div>
                </div>
              </ng-container>

              <!-- dateTimes -->
              <ng-container *ngSwitchCase="'dateTime'">
                <div class="display-flex flex-column" [attr.guid]="question.get('guid')?.value">
                  <div class="display-flex align-items-center mb-4">
                    <mat-icon
                      *ngIf="
                        question.get('displayMode')?.value === DisplayMode.Variance &&
                        question.get('valueDate')?.value &&
                        question.get('valueTime')?.value
                      "
                      class="display-flex align-items-center done-all-icon mb-4"
                      [ngClass]="{
                    'done-all-icon-changed': question.get('defaultValueDate')?.value &&
                      question.get('defaultValueTime')?.value &&
                      (question.get('defaultValueDate')?.value?.getTime?.() !== question.get('valueDate')?.value?.getTime?.() ||
                       question.get('defaultValueTime')?.value?.getTime?.() !== question.get('valueTime')?.value?.getTime?.())
                  }">
                      done_all
                    </mat-icon>
                    <span class="question-title">
                      {{ question.get('title')?.value }}
                      <span *ngIf="question.get('isRequired')?.value !== false" class="required">*</span>
                    </span>
                  </div>
                  <div class="display-flex grid-gap-8">
                    <app-date-dropdown
                      class="flex-1"
                      formControlName="valueDate"
                      [isFullWidth]="true"
                      [attrPlaceholder]="'Choose date'"
                      [errorSection]="false"></app-date-dropdown>
                    <app-radio-button-dropdown
                      class="flex-1"
                      formControlName="valueTime"
                      [allowClear]="false"
                      [allowSearch]="false"
                      [autoSortList]="false"
                      [items]="question.get('dateTimeOptions')?.value"
                      [attrPlaceholder]="'Choose time'"
                      [attrDisable]="!question.get('valueDate')?.value"
                      attrAppendTo="body"
                      [markAsInvalid]="
                        !!(!inspectForm?.get('valueDate')?.value && submitted && !question.get('valueTime')?.value)
                      "
                      [errorSection]="false"></app-radio-button-dropdown>
                  </div>

                  <div
                    class="mt-4"
                    *ngIf="
                        question.get('displayMode')?.value === DisplayMode.Variance && question.get('defaultValueDate')?.value && question.get('defaultValueTime')?.value &&
                   (question.get('defaultValueDate')?.value?.getTime?.() !== question.get('valueDate')?.value?.getTime?.() ||
                    question.get('defaultValueTime')?.value?.getTime?.() !== question.get('valueTime')?.value?.getTime?.())">
                    Changed from
                    {{ question.get('defaultValueDate')?.value | date: 'shortDate' }}
                    {{ question.get('defaultValueTime')?.value | date: 'shortTime' }}
                  </div>
                </div>
              </ng-container>

              <!-- dropdowns -->
              <ng-container *ngSwitchCase="'dropdown'">
                <div class="display-flex flex-column" [attr.guid]="question.get('guid')?.value">
                  <div class="display-flex align-items-center mb-4">
                    <mat-icon
                      *ngIf="
                        question.get('displayMode')?.value === DisplayMode.Variance && question.get('value')?.value
                      "
                      class="display-flex align-items-center done-all-icon mb-4"
                      [ngClass]="{
                        'done-all-icon-changed':
                          question.get('defaultValue')?.value &&
                          question.get('value')?.value !== question.get('defaultValue')?.value
                      }">
                      done_all
                    </mat-icon>
                    <span class="question-title">
                      {{ question.get('title')?.value }}
                      <span *ngIf="question.get('isRequired')?.value !== false" class="required">*</span>
                    </span>
                  </div>
                  <app-radio-button-dropdown
                    formControlName="value"
                    [items]="question.get('options')?.value"
                    [allowClear]="true"
                    [allowSearch]="question.get('options')?.value?.length > 7"
                    [attrPlaceholder]="'Choose option'"
                    [unsupportedValueLabel]="'Choose option'"
                    attrAppendTo="body"
                    [markAsInvalid]="submitted && question.get('value')?.invalid"
                    [errorSection]="false"></app-radio-button-dropdown>

                  <div
                    class="mt-4"
                    *ngIf="
                      question.get('displayMode')?.value === DisplayMode.Variance &&
                      question.get('options')?.value &&
                      question.get('defaultValue')?.value &&
                      question.get('value')?.value !== question.get('defaultValue')?.value
                    ">
                    Changed from
                    <ng-container *ngFor="let group of question.get('options')?.value">
                      <ng-container *ngFor="let opt of group">
                        <ng-container *ngIf="opt.value === question.get('defaultValue')?.value">
                          {{ opt.label }}
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <!-- checklists -->
              <ng-container *ngSwitchCase="'checkList'">
                <div class="display-flex flex-column" [attr.guid]="question.get('guid')?.value">
                  <div class="display-flex align-items-center mb-4">
                    <mat-icon
                      *ngIf="
                        question.get('displayMode')?.value === DisplayMode.Variance && question.get('value')?.value
                      "
                      class="display-flex align-items-center done-all-icon mb-4"
                      [ngClass]="{
                        'done-all-icon-changed':
                          question.get('defaultValue')?.value &&
                          !arraysEqual(question.get('value')?.value, question.get('defaultValue')?.value)
                      }">
                      done_all
                    </mat-icon>
                    <span class="question-title">
                      {{ question.get('title')?.value }}
                      <span *ngIf="question.get('isRequired')?.value !== false" class="required">*</span>
                    </span>
                  </div>
                  <app-radio-button-dropdown
                    formControlName="value"
                    [items]="question.get('options')?.value"
                    [allowClear]="true"
                    [allowSearch]="question.get('options')?.value?.length > 7"
                    [multiSelect]="true"
                    [groupLabelBold]="true"
                    [attrPlaceholder]="'Choose option'"
                    [unsupportedValueLabel]="'Choose option'"
                    attrAppendTo="body"
                    [errorSection]="false"
                    [markAsInvalid]="submitted && question.get('value')?.invalid"></app-radio-button-dropdown>

                  <div
                    class="mt-4"
                    *ngIf="
                      question.get('displayMode')?.value === DisplayMode.Variance &&
                      question.get('defaultValue')?.value &&
                      !arraysEqual(question.get('value')?.value, question.get('defaultValue')?.value)
                    ">
                    Changed from {{ getChecklistDefaultLabels(question) }}
                  </div>
                </div>
              </ng-container>

              <!-- radiolists -->
              <ng-container *ngSwitchCase="'radiolist'">
                <div class="display-flex flex-column" [attr.guid]="question.get('guid')?.value">
                  <div class="display-flex align-items-center mb-4">
                    <mat-icon
                      *ngIf="
                        question.get('displayMode')?.value === DisplayMode.Variance && question.get('value')?.value
                      "
                      class="display-flex align-items-center done-all-icon mb-4"
                      [ngClass]="{
                        'done-all-icon-changed': question.get('defaultValue')?.value && hasChanged(question)
                      }">
                      done_all
                    </mat-icon>
                    <span class="question-title">
                      {{ question.get('title')?.value }}
                      <span *ngIf="question.get('isRequired')?.value !== false" class="required">*</span>
                    </span>
                  </div>
                  <app-radio-button
                    formControlName="value"
                    [items]="question.get('options')?.value"
                    [radioGroupClass]="
                      question.get('orientation')?.value === RadioListOrientation.Horizontal
                        ? 'display-flex flex-wrap'
                        : 'display-flex flex-column'
                    "
                    attrAppendTo="body"
                    [errorSection]="false"
                    [markAsInvalid]="submitted && question.get('value')?.invalid"></app-radio-button>

                  <div
                    class="mt-4"
                    *ngIf="
                      question.get('displayMode')?.value === DisplayMode.Variance &&
                      question.get('defaultValue')?.value &&
                      hasChanged(question)
                    ">
                    Changed from {{ getRadiolistDefaultLabels(question) }}
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <!-- Photo -->
    <ng-container *ngIf="inspectForm?.get('isPhotoVisible')?.value">
      <div
        class="w-100 display-flex flex-column justify-content-space-between grid-gap-8"
        [attr.guid]="'guid-fileUploadIds'">
        <span class="text-item-section">
          {{
            inspectForm?.get('imageCaptureMode')?.value === ImageCaptureMode.AnyFile
              ? 'Add photos & documents'
              : 'Add photos'
          }}
          <span *ngIf="isPhotoRequired" class="required">*</span>
        </span>
        <div class="display-flex grid-gap-16">
          <app-multiple-attachments
            [cleanInputAttachment]="cleanInputAttachment"
            (attachmentItemEvent)="handleAttachment($event)"
            (isUploading)="isUploading = $event"
            [allowLink]="false"
            [isResident]="true"
            [useFileIcon]="inspectForm?.get('imageCaptureMode')?.value === ImageCaptureMode.AnyFile"
            [acceptedFormats]="
              inspectForm?.get('imageCaptureMode')?.value === ImageCaptureMode.AnyFile
                ? allFileExtensions
                : imageVideoFileExtensions
            "
            class="container-attachments"
            [ngClass]="{
              'container-attachments-filled': mappedImages.length > 0,
              'container-attachments-required':
                inspectForm.get('fileUploadIds').invalid && inspectForm.get('fileUploadIds').touched
            }"></app-multiple-attachments>
          <div
            *ngIf="mappedImages.length > 0"
            class="thumbnail-slider display-flex grid-gap-16"
            [ngClass]="{ 'thumbnail-slider display-flex grid-gap-16': mappedImages.length > 0 }">
            <div
              class="thumbnail-container display-flex align-items-center justify-content-center"
              [ngClass]="{ 'thumbnail-container-file': !isImage(image) }"
              *ngFor="let image of mappedImages; let i = index">
              <img
                *ngIf="isImage(image); else fileTemplate"
                class="thumbnail"
                [attr.loading]="'lazy'"
                [src]="image?.thumbnailUri || (image?.videoDuration > 0 ? thumbnailPlaceholder : image?.cloudUri)"
                alt="Image"
                width="90"
                height="90" />

              <ng-template #fileTemplate>
                <div class="thumbnail display-flex align-items-center justify-content-center">
                  <div class="thumbnail-file-icon thumbnail-file-icon-{{ getExtension(image)?.toLowerCase() }}">
                    <div class="thumbnail-file-placeholder-text">
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                    <div class="thumbnail-file-label">{{ getExtension(image) }}</div>
                  </div>
                </div>
              </ng-template>

              <div
                class="overlay"
                [ngClass]="{ 'overlay-file': !isImage(image) }"
                (click)="viewAllPhotos(mappedImages, true, i)">
                <span class="text-item-section desktop-only">
                  View
                  <br />
                  {{ mappedImages.length > 1 ? ' (' + (i + 1) + '/' + mappedImages.length + ')' : '' }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Comments -->
    <ng-container *ngIf="inspectForm?.get('isCommentVisible')?.value">
      <div class="w-100 display-flex flex-column justify-content-space-between grid-gap-8" [attr.guid]="'guid-comment'">
        <span class="text-item-section">
          Add comments
          <span *ngIf="isCommentRequired" class="required">*</span>
        </span>
        <div
          class="container-comments overflow-hidden"
          [ngClass]="
            inspectForm.get('comment').invalid && inspectForm.get('comment').touched
              ? 'container-comments-required'
              : ''
          ">
          <textarea formControlName="comment" aria-label="comment" placeholder="Type your comment here..."></textarea>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Submit -->
  <div
    class="button-submit align-items-center justify-content-center"
    [ngClass]="{ 'button-submit-disabled': isUploading || isSubmitting }"
    *ngIf="
      this.currentAreaIndex + 1 !== this.data.residentInspection.areas?.length || currentItemIndex < totalItems - 1
    ">
    <app-button-menu
      [isDisabledStroke]="true"
      [options]="onSubmitOptions"
      [title]="onSubmitSelected?.label"
      [submitOnMainButtonClick]="true"
      size="xl"
      [btnResident]="true"
      [isInProgress]="isSubmitting"
      (submitAction)="submitForm(onSubmitSelected?.id)"
      (action)="markAs($event)"></app-button-menu>
  </div>
  <div
    class="display-flex align-items-center justify-content-center"
    *ngIf="
      this.currentAreaIndex + 1 === this.data.residentInspection.areas?.length && !(currentItemIndex < totalItems - 1)
    ">
    <button
      (click)="submitForm(true)"
      class="button-submit-simple"
      [ngClass]="{ 'button-submit-simple-disabled': isUploading || isSubmitting }"
      type="button"
      mat-button
      [disabled]="isUploading">
      <div class="display-flex align-items-center justify-content-center grid-gap-8">
        <mat-spinner *ngIf="isSubmitting" color="accent" diameter="20"></mat-spinner>
        <span>Done</span>
      </div>
    </button>
  </div>
</form>

<!-- Instructions -->
<ng-template #instructionsSheet>
  <div class="w-100 display-flex flex-column grid-gap-24">
    <div class="w-100 display-flex align-items-center justify-content-space-between">
      <span class="text-item-name">Instructions</span>
      <div class="display-flex">
        <button
          mat-button
          matRipple
          color="primary"
          type="button"
          aria-label="close-button"
          class="icon"
          (click)="closeInstructions()">
          <app-icon
            [svg]="EIcon.CLOSE_SMALL"
            [iconWidth]="24"
            [iconHeight]="24"
            [iconColor]="EColorPalette.cGray5"></app-icon>
        </button>
      </div>
    </div>
    <div class="text-instructions" [innerHTML]="currentArea?.items[currentItemIndex]?.instructions"></div>
    <div class="buttons-container">
      <button (click)="closeInstructions()" class="button-instructions" type="button" mat-button>Got it!</button>
      <button
        (click)="closeInstructions(true)"
        class="button-instructions button-instructions-secondary"
        type="button"
        mat-button>
        Don't show again
      </button>
    </div>
  </div>
</ng-template>

<ng-template #storageConfirmSheet>
  <div class="w-100 display-flex flex-column grid-gap-24">
    <div class="w-100 display-flex align-items-center justify-content-space-between">
      <span class="text-item-name">Discard Changes</span>
      <div class="display-flex">
        <button
          mat-button
          matRipple
          color="primary"
          type="button"
          aria-label="close-button"
          class="icon"
          (click)="dialogRef.close()">
          <app-icon
            [svg]="EIcon.CLOSE_SMALL"
            [iconWidth]="24"
            [iconHeight]="24"
            [iconColor]="EColorPalette.cGray5"></app-icon>
        </button>
      </div>
    </div>
    <div class="text-instructions">Unsaved changes will be lost, continue?</div>
    <div class="buttons-container">
      <button (click)="confirmDiscard()" class="button-instructions" type="button" mat-button>Discard & Close</button>
      <button
        (click)="dialogRef.close()"
        class="button-instructions button-instructions-secondary"
        type="button"
        mat-button>
        Cancel
      </button>
    </div>
  </div>
</ng-template>
